"use client";
import React from "react";
import {useState, useEffect} from "react";

export default function FeaturesCarousel({data}) {
    const {title, subtitle, features = [], background = {}} = data || {};
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % features.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [features.length]);

    const bgStyle =
        background.type === "gradient"
            ? {backgroundImage: background.value}
            : background.type === "color"
                ? {backgroundColor: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    return (
        <section className="py-20 px-4" style={bgStyle}>
            <div className="max-w-4xl mx-auto text-center">
                {title && <h2 className="text-3xl font-bold mb-2">{title}</h2>}
                {subtitle && <p className="text-gray-600 mb-8">{subtitle}</p>}

                <div className="bg-white shadow-md rounded-xl p-8 transition-all duration-500">
                    <div className="text-4xl mb-4">{features[current]?.icon}</div>
                    <h3 className="text-xl font-semibold">{features[current]?.title}</h3>
                    <p className="text-gray-600 mt-2">{features[current]?.description}</p>
                    {features[current]?.link?.href && (
                        <a href={features[current].link.href}
                           className="text-blue-600 underline text-sm mt-2 inline-block">
                            {features[current].link.text || "Learn more"}
                        </a>
                    )}
                </div>
            </div>
        </section>
    );
}